// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3236":"15a23ae0","3552":"0ac749f8","8409":"2ddd0dd6"}[chunkId] + ".chunk.css";
};